export enum ArtificialCustomEvent {
  ToggleExpandSections = 'toggle_expand_sections',
  ExitBlockCreator = 'exit_block_creator',
  SubmitInlineBlockEdit = 'submit_inline_block_edit',
  SubmitAsNewInlineBlockEdit = 'submit_as_new_inline_block_edit',
}

export type BaseEvent<Name extends string, Payload> = CustomEvent<{ operation: Name; value: Payload }>;

export type ExitBlockCreatorEvent = BaseEvent<ArtificialCustomEvent.ExitBlockCreator, undefined>;
export type SubmitAsNewInlineBlockEditEvent = BaseEvent<
  ArtificialCustomEvent.SubmitAsNewInlineBlockEdit,
  { name: string }
>;
export type SubmitInlineBlockEditEvent = BaseEvent<ArtificialCustomEvent.SubmitInlineBlockEdit, never>;
export type ToggleExpandSectionsEvent = BaseEvent<ArtificialCustomEvent.ToggleExpandSections, boolean>;

// Union for all custom Artificial events
export type ArtificialCustomEventUnion =
  | ExitBlockCreatorEvent
  | SubmitAsNewInlineBlockEditEvent
  | SubmitInlineBlockEditEvent
  | ToggleExpandSectionsEvent;

export type ArtificialOperation = ArtificialCustomEventUnion['detail']['operation'];
export type ArtificialEventDetail = ArtificialCustomEventUnion['detail'];

export type EventOfType<T extends ArtificialOperation> = Extract<
  ArtificialCustomEventUnion,
  { detail: { operation: T } }
>;
export type GetEventValue<E extends ArtificialCustomEventUnion> = E['detail']['value'];
